export default "__VITE_ASSET__Cthisndz__"